import { TranslateService } from '@ngx-translate/core';
//import { Observable } from 'rxjs/Observable';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { BufferChangeHistory } from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';

type Data = { changes: BufferChangeHistory[], sku: string, warehouseCode: string, canSend: boolean, isAll?: boolean };

export class BufferChangeHistoryTabInfo extends TabInfoBase<Data> {
    constructor(translateService: TranslateService, data: Data) {
        super(translateService.get(['Sku', 'BufferChangeHistory']).map(t => `${t['Sku']} ${data.sku} - ${t['BufferChangeHistory']}`), data);
        //super(new Observable<string>(s => {
        //        translateService.get(['Sku', 'BufferChangeHistory']).subscribe(t => {
        //            const header = `${t.Sku} ${data.sku} - ${t.BufferChangeHistory}`;

        //            s.next(header);
        //            s.complete();
        //        });
        //    }),
        //    data);
    }

    get id(): string {
        return BufferChangeHistoryTabInfo.id;
    }

    static readonly id = 'BCH';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-history/buffer-change-history-tab-info.ts